import featureService from '@/api/feature'
import { FEATURES_SET } from '../types'

export default {
  namespaced: true,
  getters: {
  },
  mutations: {
    [FEATURES_SET] (state, features) {
      state.features = features
    }
  },
  actions: {
    getFeatures: function ({dispatch}) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        featureService.getFeaturesOfAnAdmin().then((response) => {
          resolve(response.data)
          dispatch('Global/hideLoading', null, {root: true})
        }).catch((error) => {
          reject(error)
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    saveFeatures: function ({dispatch}, feature) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        featureService.saveFeatures(feature).then(() => {
          dispatch('Global/getInitialSettings', null, { root: true })
          resolve()
        }).catch((error) => {
          reject(error)
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    }
  }
}
